/**
 * Custom JS (Enterprise theme). Se temaets dokumentation for events: on:variant:change, on:cart:add,
 * on:cart:error, on:line-item:change, dispatch:cart-drawer:open/refresh/close m.fl.
 */
$(document).ready(function() {
  if ( document.documentElement.lang.toLowerCase() === "nl" ) {
//It will hide the parent which child contain only Closed not Closed Case
$("details-disclosure .filter .flex-auto").filter(function() {
    return $(this).text() === "Kwaliteit garen";
}).closest('details-disclosure').hide();
    }
});

/**
 * DAVI: Feedback på knapperne i produktkort ("Se 24 farver" / "Se opskrift" osv.).
 * - Knappen bliver grøn og trykkes ind, så snart man rører/klikker.
 * - Ved klik vises en indlæser i knappen, mens produktsiden åbner.
 * - Produktsiden hentes i baggrunden allerede ved hover/touch, så den åbner hurtigere.
 */
(function () {
  if (window.daviCardBtnBound) return;
  window.daviCardBtnBound = true;

  var SELECTOR = '.card--product .mf-card-product-button';
  var prefetched = {};

  function prefetch(link) {
    var href = link && link.href;
    if (!href || prefetched[href] || link.origin !== location.origin) return;
    prefetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  }

  function clearPressed() {
    document.querySelectorAll(SELECTOR + '.davi-pressed').forEach(function (b) {
      b.classList.remove('davi-pressed');
    });
  }

  document.addEventListener('pointerdown', function (evt) {
    var btn = evt.target.closest && evt.target.closest(SELECTOR);
    if (!btn) return;
    btn.classList.add('davi-pressed');
    prefetch(btn);
  }, { passive: true });

  ['pointerup', 'pointercancel'].forEach(function (type) {
    document.addEventListener(type, function () { setTimeout(clearPressed, 120); }, { passive: true });
  });

  document.addEventListener('mouseover', function (evt) {
    var btn = evt.target.closest && evt.target.closest(SELECTOR);
    if (btn) prefetch(btn);
  }, { passive: true });

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest(SELECTOR);
    if (!btn || btn.tagName !== 'A') return;
    if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
    if (btn.target && btn.target !== '_self') return;
    btn.classList.remove('davi-pressed');
    btn.classList.add('davi-going');
    btn.setAttribute('aria-busy', 'true');
    // Sikkerhedsnet, hvis navigationen ikke sker (fx en app stopper den).
    setTimeout(function () {
      btn.classList.remove('davi-going');
      btn.removeAttribute('aria-busy');
    }, 8000);
  });

  // Når man går tilbage (bfcache), skal knapperne være normale igen.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll(SELECTOR + '.davi-going, ' + SELECTOR + '.davi-pressed').forEach(function (b) {
      b.classList.remove('davi-going', 'davi-pressed');
      b.removeAttribute('aria-busy');
    });
  });
})();
